/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc
 */

export const AssetCoordinatesDiscriminantKey = '@c';
export const CompositeTargetingConfigTypename = 'com.hubspot.personalize.models.CompositeTargetingConfig';
export const CompositeTargetingConfigDiscriminant = 'COMPOSITE';
export const CompositeTargetingConfigDiscriminantKey = 'type';
export const CrmObjectTargetingConfigTypename = 'com.hubspot.personalize.models.CrmObjectTargetingConfig';
export const CrmObjectTargetingConfigDiscriminant = 'CRM_OBJECT';
export const CrmObjectTargetingConfigDiscriminantKey = 'type';
export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminant = '.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminantKey = '@c';
export const MarketingEmailCoordinatesTypename = 'com.hubspot.personalize.models.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminant = '.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminantKey = '@c';
export const SegmentTargetingConfigTypename = 'com.hubspot.personalize.models.SegmentTargetingConfig';
export const SegmentTargetingConfigDiscriminant = 'SEGMENT';
export const SegmentTargetingConfigDiscriminantKey = 'type';
export const TargetingConfigDiscriminantKey = 'type';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminant = '.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminantKey = '@c';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminant = '.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminantKey = '@c';
export let ComHubspotPersonalizeModels;
(function (_ComHubspotPersonalizeModels) {})(ComHubspotPersonalizeModels || (ComHubspotPersonalizeModels = {}));
export const AiExecutionInputsDiscriminantKey = '@c';
export const LandingPageVariantGenerationInputsTypename = 'com.hubspot.personalize.models.ai.LandingPageVariantGenerationInputs';
export const LandingPageVariantGenerationInputsDiscriminant = '.LandingPageVariantGenerationInputs';
export const LandingPageVariantGenerationInputsDiscriminantKey = '@c';
export const WebInteractiveVariantGenerationInputsTypename = 'com.hubspot.personalize.models.ai.WebInteractiveVariantGenerationInputs';
export const WebInteractiveVariantGenerationInputsDiscriminant = '.WebInteractiveVariantGenerationInputs';
export const WebInteractiveVariantGenerationInputsDiscriminantKey = '@c';
export const WebsitePageVariantGenerationInputsTypename = 'com.hubspot.personalize.models.ai.WebsitePageVariantGenerationInputs';
export const WebsitePageVariantGenerationInputsDiscriminant = '.WebsitePageVariantGenerationInputs';
export const WebsitePageVariantGenerationInputsDiscriminantKey = '@c';
export let ComHubspotPersonalizeModelsCore;
(function (_ComHubspotPersonalizeModelsCore) {})(ComHubspotPersonalizeModelsCore || (ComHubspotPersonalizeModelsCore = {}));
export const AssetReportDiscriminantKey = '@c';
export const LandingPageReportTypename = 'com.hubspot.personalize.models.reporting.assets.LandingPageReport';
export const LandingPageReportDiscriminant = '.LandingPageReport';
export const LandingPageReportDiscriminantKey = '@c';
export const MarketingEmailReportTypename = 'com.hubspot.personalize.models.reporting.assets.MarketingEmailReport';
export const MarketingEmailReportDiscriminant = '.MarketingEmailReport';
export const MarketingEmailReportDiscriminantKey = '@c';
export const WebInteractiveReportTypename = 'com.hubspot.personalize.models.reporting.assets.WebInteractiveReport';
export const WebInteractiveReportDiscriminant = '.WebInteractiveReport';
export const WebInteractiveReportDiscriminantKey = '@c';
export const WebsitePageReportTypename = 'com.hubspot.personalize.models.reporting.assets.WebsitePageReport';
export const WebsitePageReportDiscriminant = '.WebsitePageReport';
export const WebsitePageReportDiscriminantKey = '@c';
export const createPersonalizationRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'createPersonalization',
  auth: 'app',
  fingerprint: 'hSNOXxonPfmzD1dJs3bzSA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createPersonalizationForContentRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'createPersonalizationForContent',
  auth: 'app',
  fingerprint: 'UasG0ql4dAezD1dJs3bzSA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createPersonalizationStrategyForContentRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'createPersonalizationStrategyForContent',
  auth: 'app',
  fingerprint: 'LAW5vGOZtpJffwOJHGcqrA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createPersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'createPersonalizationStrategy',
  auth: 'app',
  fingerprint: 'Hd0halCjDgNffwOJHGcqrA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPersonalizationRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'getPersonalization',
  auth: 'app',
  fingerprint: '5hfx69cY6bizD1dJs3bzSA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'getPersonalizationStrategy',
  auth: 'app',
  fingerprint: 'dELPPO7TUo1ffwOJHGcqrA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTotalStrategiesCountRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'getTotalStrategiesCount',
  auth: 'app',
  fingerprint: 'CxFFNCrOqOgViIaTLWG1rg6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listPersonalizedAssetsRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'listPersonalizedAssets',
  auth: 'app',
  fingerprint: 'rpZabjnNExVxst4xrTCi0A6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeRpc',
  rpcName: 'updatePersonalizationStrategy',
  auth: 'app',
  fingerprint: 'kmWpL3dLs-BffwOJHGcqrA6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};